(function () {
  "use strict";

  class CaninePainCalculator extends HTMLElement {
    connectedCallback() {
      if (this.__caninePainInitialized) return;
      this.__caninePainInitialized = true;

      var root = this;

      (function(){
        function fallbackCopy(text, btn){
          var ta = root.ownerDocument.createElement("textarea");
          ta.value = text;
          ta.setAttribute("readonly", "");
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          root.appendChild(ta);
          ta.select();
          try {
            root.ownerDocument.execCommand("copy");
            var t = btn.textContent;
            btn.textContent = "Copied ✓";
            setTimeout(function(){ btn.textContent = t; }, 1500);
          } catch (e) {
            btn.textContent = "Copy failed";
          }
          root.removeChild(ta);
        }

        var qNames = ["q1","q2","q3","q4","q5","q6"];
        var scoreVal = root.querySelector("#"+"scoreVal");
        var scoreMax = root.querySelector("#"+"scoreMax");
        var meterFill = root.querySelector("#"+"meterFill");
        var verdict = root.querySelector("#"+"verdict");
        var verdictSub = root.querySelector("#"+"verdictSub");
        var progress = root.querySelector("#"+"progress");
        var noMobility = root.querySelector("#"+"noMobility");
        var mobilitySec = root.querySelector("#"+"mobilitySec");

        function activeQs(){
          return noMobility.checked ? ["q1","q2","q4","q5","q6"] : qNames;
        }

        function recalc(){
          var qs = activeQs();
          var total = 0, answered = 0;
          qs.forEach(function(n){
            var sel = root.querySelector('input[name="'+n+'"]:checked');
            if(sel){ total += parseInt(sel.value,10); answered++; }
          });
          var max = noMobility.checked ? 20 : 24;
          var threshold = noMobility.checked ? 5 : 6;

          scoreVal.textContent = total;
          scoreMax.textContent = max;
          meterFill.style.width = (total/max*100)+"%";

          // meter colour
          var mColor = "var(--cpc-green)";
          if(total >= threshold) mColor = "var(--cpc-red)";
          else if(total >= threshold-2) mColor = "var(--cpc-amber)";
          meterFill.style.background = mColor;

          progress.textContent = answered + " of " + qs.length + " sections scored";

          verdict.className = "verdict";
          if(answered < qs.length){
            verdict.classList.add("low");
            verdict.childNodes[0].nodeValue = "In progress";
            verdictSub.textContent = "Score " + total + "/" + max + " so far — complete all sections";
          } else if(total >= threshold){
            verdict.classList.add("high");
            verdict.childNodes[0].nodeValue = "Analgesia recommended";
            verdictSub.textContent = "Score " + total + "/" + max + " ≥ " + threshold + " threshold — provide / escalate pain relief and reassess";
          } else {
            verdict.classList.add("low");
            verdict.childNodes[0].nodeValue = "Below intervention threshold";
            verdictSub.textContent = "Score " + total + "/" + max + " (threshold " + threshold + ") — continue monitoring & reassess";
          }
        }

        root.querySelectorAll('#glasgow input[type="radio"]').forEach(function(r){
          r.addEventListener("change", recalc);
        });

        noMobility.addEventListener("change", function(){
          if(noMobility.checked){
            mobilitySec.classList.add("disabled");
            var sel = root.querySelector('input[name="q3"]:checked');
            if(sel) sel.checked = false;
          } else {
            mobilitySec.classList.remove("disabled");
          }
          recalc();
        });

        root.querySelector("#"+"resetBtn").addEventListener("click", function(){
          root.querySelectorAll('#glasgow input[type="radio"]').forEach(function(r){ r.checked=false; });
          noMobility.checked = false;
          mobilitySec.classList.remove("disabled");
          recalc();
        });

        root.querySelector("#"+"copyBtn").addEventListener("click", function(){
          var qs = activeQs();
          var total = 0, answered = 0;
          var labels = {q1:"Vocalisation",q2:"Attention to wound",q3:"Mobility",q4:"Response to touch",q5:"Demeanour",q6:"Posture/comfort"};
          var lines = [];
          qs.forEach(function(n){
            var sel = root.querySelector('input[name="'+n+'"]:checked');
            if(sel){
              total += parseInt(sel.value,10); answered++;
              var lab = sel.parentNode.querySelector(".label").textContent;
              lines.push("  " + labels[n] + ": " + lab + " (" + sel.value + ")");
            } else {
              lines.push("  " + labels[n] + ": —");
            }
          });
          var max = noMobility.checked ? 20 : 24;
          var threshold = noMobility.checked ? 5 : 6;
          var summary = "CMPS-SF Canine Pain Score\n" +
            "-------------------------\n" +
            lines.join("\n") + "\n" +
            "-------------------------\n" +
            "TOTAL: " + total + "/" + max + (noMobility.checked ? " (mobility not assessed)" : "") + "\n" +
            "Intervention threshold: " + threshold + "/" + max + "\n" +
            "Result: " + (total >= threshold ? "ANALGESIA RECOMMENDED" : "Below threshold") + "\n" +
            "Assessed via ASK A VET™ Canine Pain Calculator";
          var btn = this;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(summary).then(function(){
              var t = btn.textContent; btn.textContent = "Copied ✓";
              setTimeout(function(){ btn.textContent = t; }, 1500);
            }).catch(function(){
              fallbackCopy(summary, btn);
            });
          } else {
            fallbackCopy(summary, btn);
          }
        });

        // ---- Colorado (CSU) ----
        var csuVal = root.querySelector("#"+"csuVal");
        var csuMeter = root.querySelector("#"+"csuMeter");
        var csuVerdict = root.querySelector("#"+"csuVerdict");
        var csuSub = root.querySelector("#"+"csuSub");
        var csuTiers = {
          "0":{t:"No pain — comfortable",c:"var(--cpc-green)",m:"Dog is comfortable. Continue routine monitoring."},
          "1":{t:"Minimal pain",c:"#5cb85c",m:"Mild signs only. Monitor closely and rescore."},
          "2":{t:"Mild pain — reassess analgesia",c:"var(--cpc-amber)",m:"Reassess the analgesic plan and rescore after intervention."},
          "3":{t:"Moderate pain — reassess analgesia",c:"#e2711d",m:"Provide / escalate analgesia now and rescore."},
          "4":{t:"Severe pain — reassess analgesia",c:"var(--cpc-red)",m:"Urgent: escalate analgesia and reassess frequently."}
        };
        function csuRecalc(){
          var sel = root.querySelector('input[name="csu"]:checked');
          root.querySelectorAll("#csuLevels .level").forEach(function(l){
            l.classList.toggle("sel", l.contains(sel));
          });
          csuVerdict.className = "verdict";
          if(!sel){
            csuVal.textContent = "–";
            csuMeter.style.width = "0";
            csuVerdict.classList.add("low");
            csuVerdict.childNodes[0].nodeValue = "Select a level";
            csuSub.textContent = "Choose the single level that best fits the dog";
            return;
          }
          var v = sel.value, tier = csuTiers[v];
          csuVal.textContent = v;
          csuMeter.style.width = (parseInt(v,10)/4*100)+"%";
          csuMeter.style.background = tier.c;
          csuVerdict.classList.add(v>=2 ? (v>=3?"high":"mid") : "low");
          csuVerdict.childNodes[0].nodeValue = tier.t;
          csuSub.textContent = tier.m;
        }
        root.querySelectorAll('input[name="csu"]').forEach(function(r){
          r.addEventListener("change", csuRecalc);
        });
        root.querySelector("#"+"csuReset").addEventListener("click", function(){
          root.querySelectorAll('input[name="csu"]').forEach(function(r){ r.checked=false; });
          csuRecalc();
        });
        root.querySelector("#"+"csuCopy").addEventListener("click", function(){
          var sel = root.querySelector('input[name="csu"]:checked');
          var btn = this;
          if(!sel){ btn.textContent="Select a level"; setTimeout(function(){btn.textContent="Copy summary";},1500); return; }
          var v = sel.value, tier = csuTiers[v];
          var title = sel.closest(".level").querySelector(".lvl-title").textContent;
          var summary = "CSU Canine Acute Pain Scale\n" +
            "-------------------------\n" +
            "SCORE: " + v + "/4 — " + title + "\n" +
            "Assessment: " + tier.t + "\n" +
            "Action: " + tier.m + "\n" +
            (v>=2 ? "Reassess analgesic plan: YES\n" : "") +
            "Assessed via ASK A VET™ Canine Pain Calculator";
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(summary).then(function(){
              var t=btn.textContent; btn.textContent="Copied ✓"; setTimeout(function(){btn.textContent=t;},1500);
            }).catch(function(){ fallbackCopy(summary, btn); });
          } else {
            fallbackCopy(summary, btn);
          }
        });
        csuRecalc();

        // Tabs
        root.querySelectorAll(".tab").forEach(function(t){
          t.addEventListener("click", function(){
            if(t.classList.contains("soon")) return;
            root.querySelectorAll(".tab").forEach(function(x){x.classList.remove("active")});
            root.querySelectorAll(".panel").forEach(function(x){x.classList.remove("active")});
            t.classList.add("active");
            root.querySelector("#"+t.dataset.tab).classList.add("active");
          });
        });

        recalc();
      })();
    }
  }

  if (!customElements.get("s-canine-pain-calculator")) {
    customElements.define("s-canine-pain-calculator", CaninePainCalculator);
  }
})();
